<template>
  <div class="home">
    <div class="home_head">
      <div class="home_main">
        <div class="home_main_title">
          用户
          <span>{{nickname}}</span>，您好
        </div>
        <div >
          <div class="home_main_vip" v-show="!isVip">升级账号为VIP请继续</div>
          <div v-show="isVip" class="home_main_vip">您当前使用的是VIP账号</div>
          <!-- <p style="text-align:center;" v-show="isVip">
            <a href="/">返回首页</a>
          </p> -->
        </div>
        <div v-show="!isVip">
          <router-link to="/info">
            <van-button round type="info" size="large">申请升级为vip用户</van-button>
          </router-link>
        </div>
        <div v-show="isVip" style="text-align:center;color:#317bd2!important;">
        
            <!-- <span style="color: rgb(49, 123, 210)!important;" @click="metelLink()">前往MeTeL</span> -->
            <a href="http://m.metel.cn/" target="_blank"  style="color: rgb(49, 123, 210)!important;">前往MeTeL</a>
             
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import user_service from "@/service/user_service";
export default {
  data() {
    return {
      nickname: "",
      isVip: false,
      isReApply: false
    };
  },
  async created() {
    let token = this.$cookie.get("access_token");
    let user = await this.fetchUser(token)
      .then(user => {
        return user;
      })
      .catch(err => {
        return this.renewToken(this.$cookie.get("refresh_token"));
      });
    // 查询当前用户是否重复提交
    let result = await user_service.getReapply();
    console.log(user, result);
    this.nickname = user.nickname;
    this.isReApply = result.data > -1;
    if (user.role >= 32) {
      this.isVip = true;
    }
  },
  methods: {
    metelLink(){
       window.open('http://m.metel.cn/');
    },
    //  根据token获取用户信息
    fetchUser(token) {
      return user_service.oauth2UserInfo(token).then(user => {
        return user;
      });
    },
    // 刷新token
    renewToken(refresh_token) {
      return user_service
        .oauth2RefreshToken(refresh_token)
        .then(x => {
          console.log(x);
          user_service.setCookie(x);
          return this.fetchUser(x.access_token);
        })
        .catch(err => {
          console.log(err);
          this.$router.push("/");
        });
    }
  }
};
</script>
<style scoped>
.home {
  height: 100%;
  width: 100%;
}
.home_head {
  width: 100%;
  height: 40vh;
  background: linear-gradient(90deg, #319cc4 0%, #317bd2 50%, #6471d0 100%);
  position: relative;
}
.home_main {
  position: absolute;
  top: 10vh;
  left: 3vw;
  right: 3vw;
  background: #ffffff;
  min-height: 15rem;
  border-radius: 6px;
  padding-top: 20%;
  padding-left: 5%;
  padding-right: 5%;
}
.home_main_title {
  font-weight: 400;
  color: #555555;
  text-align: center;
}
.home_main_vip {
  font-weight: bold;
  color: #333333;
  line-height: 3rem;
  font-size: 1.2rem;
  text-align: center;
  margin-bottom: 2rem;
}
</style>


// WEBPACK FOOTER //
// src/components/home.vue